import * as service from './service'
export default {
  namespace: 'customerServiceHome',
  state: {
    articleList: [],
    citySwitch: false
  },
  effects: {
    * queryArticlesByPlatformId ({ payload }, { call, put }) {
      const res = yield call(service.queryArticlesByPlatformId, payload)
      yield put({
        type: 'save',
        payload: {
          articleList: res.data.data || []
        }
      })
    },
    * citySwitch ({ payload }, { call, put }) {
      const res = yield call(service.citySwitch, payload)
      console.log(res)
      yield put({
        type: 'save',
        payload: {
          citySwitch: res.data.data || false
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
